/* PULLORAX likes (1 Oct 2026, owner approved).
   Real like counts, social-network style. Loaded by sections/pullorax-likes.liquid
   only once the PulloraX Community web app is configured.

   WHAT IS COUNTED
     p:<product handle>            the product heart (= the wishlist heart)
     a:<article key>               the heart under a magazine article title
     c:<article key>#<card number> the heart on a card in a set file gallery
   One voter counts once per item: a signed-in customer (signed id) or, signed
   out, one random id per device. The PulloraX Community script de-duplicates,
   rate-limits and stores the counts; nothing is ever invented.

   DISPLAY RULES
     - A count shows only from data-min (5) upwards.
     - A tap updates the number on the spot (pending +1 / -1 kept for 10 min
       until the server count catches up, so nothing is counted twice).
     - "Popular" badge: the nightly script's list (top 10 products, top 3 cards
       per set, 10+ likes each).

   SAVING
     Product hearts are the wishlist (assets/pullorax-wishlist.js, untouched -
     this file only listens to its add/remove events). Magazine likes are their
     own list, localStorage pullorax_maglikes_v1, kept on the customer account
     (metafield pullorax.mag_likes) when signed in - same five sync rules as
     assets/pullorax-wishlist-sync.js - and shown on the wishlist page under
     "Liked in the magazine".

   RECONCILE: on every page the device compares what it has liked with what it
   has reported, and reports the difference. Old wishlist saves are therefore
   counted too, and a lost request is repaired on the next page view. */
(function(){'use strict';
if(window.__pxLikes)return;window.__pxLikes=true;
var cfg=document.querySelector('[data-px-likes]');if(!cfg)return;
var D=cfg.dataset,API=D.url;if(!API)return;
var MIN=+D.min||5;
var T={like:D.tLike||'Like',unlike:D.tUnlike||'Unlike',pop:D.tPop||'Popular',article:D.tArticle||'this article',
  head:D.tHead||'Liked in the magazine',remove:D.tRemove||'Remove',likes:D.tLikes||'likes'};
var WL='pullorax_wishlist_v1',ML='pullorax_maglikes_v1',SENT='pullorax_likes_sent_v1',PEND='pullorax_likes_pending_v1',
    DEVK='pullorax_dev',MLD='pullorax_maglikes_dirty';
var HEART='<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.7l-1.2-1.1C6 15.3 3 12.6 3 9.2 3 6.5 5.1 4.4 7.8 4.4c1.5 0 3 .7 4.2 1.9 1.2-1.2 2.7-1.9 4.2-1.9 2.7 0 4.8 2.1 4.8 4.8 0 3.4-3 6.1-7.8 10.4L12 20.7z"/></svg>';

function get(k){try{return localStorage.getItem(k)}catch(e){return null}}
function set(k,v){try{localStorage.setItem(k,v)}catch(e){}}
function del(k){try{localStorage.removeItem(k)}catch(e){}}
function jget(k,def){try{var v=JSON.parse(get(k)||'null');return v==null?def:v}catch(e){return def}}
function jset(k,v){set(k,JSON.stringify(v))}
function jsonEl(id){var s=document.getElementById(id);if(!s)return null;try{return JSON.parse(s.textContent)}catch(e){return null}}
function dev(){var d=get(DEVK)||'';if(!/^[a-f0-9]{24}$/.test(d)){d='';var a=new Uint8Array(12);try{(window.crypto||window.msCrypto).getRandomValues(a)}catch(e){for(var j=0;j<12;j++)a[j]=Math.floor(Math.random()*256)}
  for(var i=0;i<a.length;i++)d+=('0'+a[i].toString(16)).slice(-2);set(DEVK,d)}return d}
function signed(){return !!(D.cid&&D.sig)}
function post(body){body.dev=dev();if(signed()){body.cid=D.cid;body.sig=D.sig}
  try{fetch(API,{method:'POST',mode:'no-cors',keepalive:true,headers:{'Content-Type':'text/plain;charset=utf-8'},body:JSON.stringify(body)})}catch(e){}}
function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}

var DATA=jsonEl('pxLikesData')||{};
var PROD=(DATA.products&&typeof DATA.products==='object')?DATA.products:{};
var PC=PROD.c||{},PPOP=PROD.pop||[];
var ART=DATA.art||null;
var AL=(DATA.likes&&typeof DATA.likes==='object')?DATA.likes:{};
var AC=AL.c||{},APOP=AL.pop||[];

/* ---------- counting ---------- */
function report(target,on){var s=jget(SENT,{});if(on)s[target]=1;else delete s[target];jset(SENT,s);
  post({type:'like',t:target.charAt(0),k:target.slice(2),on:on?1:0})}
function pend(target,d,base){var p=jget(PEND,{}),now=Date.now();for(var k in p){if(now-p[k].ts>600000)delete p[k]}
  p[target]={d:d,base:base||0,ts:now};jset(PEND,p)}
function shown(target,server){var n=+server||0,p=jget(PEND,{})[target];
  if(p&&Date.now()-p.ts<600000&&p.base===n)n+=p.d;return Math.max(0,n)}
function fmt(n){try{return new Intl.NumberFormat(document.documentElement.lang||undefined,{notation:n>=10000?'compact':'standard'}).format(n)}catch(e){return String(n)}}

/* ---------- magazine list (device + account) ---------- */
function mlRead(){var v=jget(ML,[]);return Array.isArray(v)?v:[]}
function mlWrite(items){jset(ML,items)}
function mlHas(k){return mlRead().some(function(x){return x&&x.k===k})}
function mlPush(items){if(!signed())return;post({type:'maglikes',items:items.slice(-300)})}
function mlKey(items){return items.map(function(x){return x&&x.k}).filter(Boolean).sort().join('|')}
function mlChanged(){if(signed()){set(MLD,String(Date.now()));mlPush(mlRead())}}
function mlLoad(){if(!signed())return;var srv=jsonEl('pxMagLikesServer');if(!Array.isArray(srv))srv=null;
  var loc=mlRead(),fk='pullorax_maglikes_synced_'+D.cid,synced=get(fk)==='1',dirty=+(get(MLD)||0);
  function done(){set(fk,'1');del(MLD)}
  if(!srv){if(loc.length)mlPush(loc);done();return}
  if(!synced){var m=srv.slice();loc.forEach(function(x){if(x&&x.k&&!m.some(function(y){return y&&y.k===x.k}))m.push(x)});
    if(mlKey(m)!==mlKey(loc))mlWrite(m);if(mlKey(m)!==mlKey(srv))mlPush(m);done();return}
  if(mlKey(loc)===mlKey(srv)){del(MLD);return}
  if(dirty&&Date.now()-dirty<180000){mlPush(loc);return}
  mlWrite(srv);done()}

/* ---------- reconcile: liked here vs reported ---------- */
function reconcile(){var want={};
  (jget(WL,[])||[]).forEach(function(x){if(x&&x.handle)want['p:'+x.handle]=1});
  mlRead().forEach(function(x){if(x&&x.k)want[(x.kind==='c'?'c:':'a:')+x.k]=1});
  var sent=jget(SENT,{}),n=0,k;
  for(k in want){if(!sent[k]&&n<30){report(k,true);n++}}
  for(k in sent){if(!want[k]&&n<30){report(k,false);n++}}}

/* ---------- product hearts ---------- */
function pill(host,n,cls){var el=host.querySelector(':scope > .px-like-n');
  if(n>=MIN){if(!el){el=document.createElement('span');el.className='px-like-n'+(cls?' '+cls:'');el.setAttribute('aria-hidden','true');host.appendChild(el)}
    el.textContent=fmt(n)}else if(el){el.remove()}}
function badge(host,on){var el=host.querySelector(':scope > .px-pop');
  if(on){if(!el){el=document.createElement('span');el.className='px-pop';el.textContent=T.pop;host.appendChild(el)}}else if(el){el.remove()}}
function renderProducts(){document.querySelectorAll('.pd-wish[data-px-wishlist]').forEach(function(btn){
  var h=btn.dataset.handle,host=btn.parentNode;if(!h||!host)return;
  var n=shown('p:'+h,PC[h]);pill(host,n);badge(host,PPOP.indexOf(h)>-1);
  if(n>=MIN){btn.setAttribute('data-px-likes-n',n)}else{btn.removeAttribute('data-px-likes-n')}})}
function onWish(on){return function(e){var h=e&&e.detail&&e.detail.item_id;if(!h)return;
  pend('p:'+h,on?1:-1,+PC[h]||0);report('p:'+h,on);renderProducts()}}

/* ---------- magazine hearts ---------- */
function likeBtn(kind,label,liked){var b=document.createElement('button');b.type='button';
  b.className='px-like px-like--'+kind+(liked?' is-liked':'');b.innerHTML=HEART+(kind==='a'?'<span class="px-like__n"></span>':'');
  b.setAttribute('aria-pressed',liked?'true':'false');b.setAttribute('aria-label',(liked?T.unlike:T.like)+' '+label);return b}
function setBtn(b,liked,label,n){b.classList.toggle('is-liked',liked);b.setAttribute('aria-pressed',liked?'true':'false');
  b.setAttribute('aria-label',(liked?T.unlike:T.like)+' '+label+(n>=MIN?' ('+n+' '+T.likes+')':''));
  var s=b.querySelector('.px-like__n');if(s){s.textContent=n>=MIN?fmt(n):'';s.hidden=n<MIN}}
function mlToggle(item,kind){var items=mlRead(),i=-1;for(var j=0;j<items.length;j++){if(items[j]&&items[j].k===item.k){i=j;break}}
  var on=i<0;if(on)items.push({k:item.k,kind:kind,title:item.title,url:item.url,image:item.image});else items.splice(i,1);
  mlWrite(items);mlChanged();return on}
var magDone=false;
function renderMag(){if(!ART||!ART.key)return;
  var aKey=ART.key,aLabel=ART.title||T.article;
  var ab=document.querySelector('[data-px-like-a]');
  if(!ab){var h1=document.querySelector('#MainContent h1');if(!h1)return;
    var row=document.createElement('div');row.className='px-like-arow';ab=likeBtn('a',aLabel,mlHas(aKey));ab.setAttribute('data-px-like-a','');row.appendChild(ab);
    h1.parentNode.insertBefore(row,h1.nextSibling);
    ab.addEventListener('click',function(){var on=mlToggle({k:aKey,title:ART.title,url:ART.url,image:ART.image},'a');
      pend('a:'+aKey,on?1:-1,+AL.a||0);report('a:'+aKey,on);renderMag()})}
  setBtn(ab,mlHas(aKey),aLabel,shown('a:'+aKey,AL.a));
  var gal=Array.isArray(ART.gallery)?ART.gallery:[];if(!gal.length)return;
  var cards=document.querySelectorAll('.pxm-gallery__grid > .pxm-gcard:not(.pxm-gcard--more)');
  cards.forEach(function(li,i){var g=gal[i];if(!g||!g.number)return;var num=String(g.number),ck=aKey+'#'+num,
    lab=(g.name||'')+' '+num,cb=li.querySelector(':scope > [data-px-like-c]');
    if(!cb){cb=likeBtn('c',lab,mlHas(ck));cb.setAttribute('data-px-like-c','');li.appendChild(cb);
      cb.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();
        var on=mlToggle({k:ck,title:(g.name||'')+' '+num+' · '+(ART.title||''),url:(ART.url||'')+'#pxm-gallery',image:g.image||''},'c');
        pend('c:'+ck,on?1:-1,+AC[num]||0);report('c:'+ck,on);renderMag()})}
    var n=shown('c:'+ck,AC[num]);setBtn(cb,mlHas(ck),lab,n);pill(li,n,'px-like-n--c');badge(li,APOP.indexOf(num)>-1)});
  magDone=true}

/* ---------- wishlist page: "Liked in the magazine" ---------- */
function renderMagPage(){var root=document.querySelector('[data-px-maglikes-page]');if(!root)return;
  var items=mlRead();root.innerHTML='';if(!items.length)return;
  var h=document.createElement('h2');h.className='px-ml__h';h.textContent=root.getAttribute('data-t-head')||T.head;root.appendChild(h);
  var ul=document.createElement('ul');ul.className='px-wl__grid px-ml__grid';
  items.slice().reverse().forEach(function(x){if(!x||!x.k)return;var li=document.createElement('li');li.className='px-wl__card';
    var a=document.createElement('a');a.className='px-wl__link';a.href=/^\//.test(x.url||'')?x.url:'#';
    if(x.image){var img=document.createElement('img');img.src=x.image;img.alt=x.title||'';img.loading='lazy';a.appendChild(img)}
    var t=document.createElement('h3');t.textContent=x.title||'';a.appendChild(t);li.appendChild(a);
    var rm=document.createElement('button');rm.type='button';rm.className='px-wl__remove';rm.textContent=root.getAttribute('data-t-remove')||T.remove;
    rm.setAttribute('aria-label',rm.textContent+' '+(x.title||''));
    rm.addEventListener('click',function(){var target=(x.kind==='c'?'c:':'a:')+x.k;mlToggle(x,x.kind);pend(target,-1,0);report(target,false);renderMagPage()});
    li.appendChild(rm);ul.appendChild(li)});
  root.appendChild(ul)}

/* ---------- boot ---------- */
function boot(){mlLoad();reconcile();renderProducts();renderMag();renderMagPage()}
document.addEventListener('add_to_wishlist',onWish(true));
document.addEventListener('remove_from_wishlist',onWish(false));
window.addEventListener('storage',function(e){if(e.key===ML){renderMag();renderMagPage()}});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
var mt=null;try{new MutationObserver(function(){clearTimeout(mt);mt=setTimeout(renderProducts,150)}).observe(document.body||document.documentElement,{childList:true,subtree:true})}catch(e){}
})();
